<div>
  <h1>Google Map Live Tracking </h1> <button (click)="back()">Move Back</button> <button (click)="next()">Move Next</button>


    
  <agm-map >
    <agm-marker *ngFor="let data of currentLatLong" [latitude]="data.currentLat" [longitude]="data.currentLng"
      [iconUrl]="icon" [markerDraggable]="true"></agm-marker>
    <agm-direction *ngFor="let data of allOriginDestinations" [origin]="data.origin" [destination]="data.destination"
      [renderOptions]="renderOptions"></agm-direction>
  </agm-map>


</div>